import { sample } from 'effector';
import { $columns, $config, setColumn, setOrder } from '../model';

/** Отработка конфига */
export const configFunc = () => {
  /** Устанавливаю колонки */
  sample({
    clock: $config,
    filter: (config) => !!config,
    fn: (config) => config!.columns,
    target: $columns,
  });

  /** Устанавливаю default наименование колонки */
  sample({
    clock: $config,
    filter: (config) => !!config?.default,
    fn: (config) => config?.default?.column!,
    target: setColumn,
  });

  /** Устанавливаю default направление */
  sample({
    clock: $config,
    filter: (config) => !!config?.default,
    fn: (config) => config?.default?.order!,
    target: setOrder,
  });
};
